//
//
//
//
//
//
//

export default {
  name: 'IconBase',
  props: {
    additionalClass: {
      required: false,
      type: String,
      default: () => '',
    },
    additionalStyle: {
      required: false,
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      iconClass: 'fas fa-square',
    };
  },
};
